import RequestCache from "./RequestCache";

export default class Shifts extends RequestCache {
    get cacheInterval() {
        return 7;
    }
    
    get link() {
        return this.links.shifts;
    }

    async getShifts(domainId) {
        const arr = [
            { field: "domainId", op: "=", value: domainId },
        ];

        const req = await this.getAllFiltered([arr]);
        return req;
    }


}
